import React from "react";
import { TFormBuilderItem } from "../../../../model/item/formBuilderItem";
import classNames from "classnames";
import { getFormBuilderInputDomType } from "../../../../model/item/formBuilderInput";

function renderFieldItemLabel(label: string, required: boolean) {
  const labelEmpty = label == null || label.length === 0;
  
  if (labelEmpty && !required) {
    return null;
  }
  
  return (
    <label
      className={classNames("item-label", {
        "item-label-required": required,
      })}
    >
      {labelEmpty && required ? "Required" : label}{/* TODO: Translation */}
    </label>
  );
}

export function renderFormBuilderItemContent(item: TFormBuilderItem) {
  const type = item.data.type;
  
  let content: JSX.Element = null;
  
  switch(type) {
    case "button": {
      const { role, settings } = item.data;
      
      content =
        <button
          className={classNames("item-button", {
            "item-button-primary": role === "submit",
            "item-button-secondary": role === "reset",
          })}
        >
          {settings.label}
        </button>;
      break;
    }
    case "checkbox": {
      const { settings } = item.data;

      content =
        <div className="item-field item-field-row">
          <input
            className="item-checkbox"
            type="checkbox"
            onClick={e => e.preventDefault()}
          />
          {renderFieldItemLabel(settings.label, false)}
        </div>;
      break;
    }
    case "date": {
      const { settings } = item.data;

      content =
        <div className="item-field">
          {renderFieldItemLabel(settings.label, settings.required)}
          <input
            className="item-date"
            type="date"
          />
        </div>;
      break;
    }
    case "input": {
      const { role, settings } = item.data;

      content =
        <div className="item-field">
          {renderFieldItemLabel(settings.label, settings.required)}
          <input
            className="item-input"
            type={getFormBuilderInputDomType(role, settings)}
            placeholder={settings.placeholder}
          />
        </div>;
      break;
    }
    case "select": {
      const { settings } = item.data;

      content =
        <div className="item-field">
          {renderFieldItemLabel(settings.label, settings.required)}
          <select className="item-select">
            {settings.placeholder.length > 0 && <option>{settings.placeholder}</option>}
            {settings.options.map((option, index) => <option key={index}>{option.label}</option>)}
          </select>
        </div>;
      break;
    }
    case "text": {
      const { role, settings } = item.data;

      content = React.createElement(
        role === "heading" ? "h2" : "p", {
          className: classNames("item-text", {
            "item-text-heading": role === "heading",
            "item-text-paragraph": role === "paragraph",
          }),
        }, settings.content);
      break;
    }
    case "textarea": {
      const { settings } = item.data;

      content =
        <div className="item-field">
          {renderFieldItemLabel(settings.label, settings.required)}
          <textarea
            className="item-textarea"
            placeholder={settings.placeholder}
          />
        </div>;
      break;
    }
    default: {
      // eslint-disable-next-line no-unused-vars
      const _exhaustiveCheck: never = type;
      content = null;
    }
  }

  return <div className="item-content">{content}</div>;
}